goog.provide('el8.appshared.eligibility');

goog.require('el8.ptdata.eligibilities');

el8.appshared.eligibility = (function() {

    var patient = null;
    var successCb = null;
    var failureCb = null;
    var pendingCb = null;
    var failureNoRetryCb = null;

    var intervalId = null;
    var attempts = 0;
    var INTERVAL = 1000;    // every second
    var MAX_ATTEMPTS = 15;  // for 15 seconds

    function reset() {
        $.el8_clearInterval(intervalId);
        intervalId = null;
        attempts = 0;
        patient = null;
        successCb = null;
        failureCb = null;
        pendingCb = null;
        failureNoRetryCb = null;
    }

    function pollFn() {
        if (el8.ptdata.currPatient) {
            // If there is a current patient, then use the eligibilities dataset
            el8.ptdata.eligibilities.load(function() {
                attempts++;
                // Keep polling until we hit MAX_ATTEMPTS or we get eligibilities returned
                if (el8.ptdata.eligibilities.hasValid()) {
                    el8.appservice.notifier.notify('Drug eligibility retrieved.');
                    if (successCb) { successCb(); }
                    reset();
                } else if (!el8.ptdata.eligibilities.isRetryAllowed()) {
                    el8.appservice.notifier.notify('Unable to retrieve drug eligibility.  Do not retry');
                    if (failureNoRetryCb) { failureNoRetryCb(el8.ptdata.eligibilities.getLastError()); }
                    reset();
                } else if (el8.ptdata.eligibilities.all().length || attempts === MAX_ATTEMPTS) {
                    el8.appservice.notifier.notify('Unable to retrieve drug eligibility.');
                    if (failureCb) { failureCb(); }
                    reset();
                }
            }, false);
        } else {
            $.el8_ajax({
                type: 'GET',
                url: el8.service.urls.get('patientEligibilities', [patient.getId()]),
                success: function(data) {
                    attempts++;
                    // Keep polling until we hit MAX_ATTEMPTS or we get eligibilities returned
                    if (data.length) {
                        el8.appservice.notifier.notify('Drug eligibility retrieved.');
                        if (successCb) { successCb(); }
                        reset();
                    } else if (attempts === MAX_ATTEMPTS) {
                        el8.appservice.notifier.notify('Unable to retrieve drug eligibility.');
                        if (failureCb) { failureCb(); }
                        reset();
                    }
                }
            });
        }
    }

    function validateEligRequest() {
        if (patient.getFirstName().length > 35) {
            return {validated: false, msg: 'FYI, Patient\'s first name of \"'+patient.getFirstName()+'\"exceeds Surescripts\'s maximum length of 35.'};

        } else if (patient.getMiddleName().length > 35) {
            return {validated: false, msg: 'FYI, Patient\'s middle name of \"'+patient.getMiddleName()+'\"exceeds Surescripts\'s maximum length of 35.'};

        } else if (patient.getLastName().length > 60) {
            return {validated: false, msg: 'FYI, Patient\'s last name of \"'+patient.getLastName()+'\"exceeds Surescripts\'s maximum length of 60.'};

        } else if (patient.getAddress().length > 55) {
            return {validated: false, msg: 'FYI, Patient\'s address of \"'+patient.getAddress()+'\"exceeds Surescripts\'s maximum length of 55.'};

        } else if (patient.getSuite().length > 55) {
            return {validated: false, msg: 'FYI, Patient\'s address, line 2, of \"'+patient.getSuite()+'\"exceeds Surescripts\'s maximum length of 55.'};

        } else if (patient.getCity().length > 30) {
            return {validated: false, msg: 'FYI, Patient\'s city of \"'+patient.getSuite()+'\"exceeds Surescripts\'s maximum length of 30.'};
        }
        return {validated: true};
    }

    return {

        isRequestInProgress: function() { return Boolean(intervalId); },

        submitRequest: function(_patient, opts) {

            opts = opts || {};
            patient = _patient;
            successCb = opts.successCb;
            failureCb = opts.failureCb;
            pendingCb = opts.pendingCb;
            failureNoRetryCb = opts.failureNoRetryCb;

            // If no outstanding requests
            if (!intervalId) {

                var _submitFn = function() {
                    el8.appservice.notifier.notify('Checking drug eligibility...');
                    var opts = {
                        type: 'POST',
                        url: el8.service.urls.get('checkEligibility', [patient.getId()]),
                        success: function() {
                            if (pendingCb) { pendingCb(); }
                            intervalId = $.el8_setInterval(pollFn, INTERVAL);
                        }
                    };
                    if (failureCb) {
                        opts['error_override'] = failureCb;
                    } else {
                        opts['error_msg'] = 'Sorry, there was an error submitting your eligibility request.';
                    }
                    $.el8_ajax(opts);
                };

                // Check to see if patient information validates
                var result = validateEligRequest();
                if (!result.validated) {
                    el8.uiwidget.alert(result.msg + '  Your request will still be sent, but there may be errors.', 
                        null, _submitFn);
                } else {
                    _submitFn();
                }

            } else {
                el8.uiwidget.alert('Eligibility request already in progress...');
            }
        }
    };

})();


